/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Linear, Timeline, TimelineLite, TweenLite} from "gsap";
import {WGGameConfig} from "../../../WGGameConfig";

export class WGBigWinCountUp extends BitmapWinCountUp {
    private _endAbortValue: number;

    constructor() {
        super({
            font: {
                name: "WGNumbersWinCountUp",
                size: 27
            },
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    public getCountUpAnimation(from: number, to: number, duration: number): Timeline {
        this._endAbortValue = to;
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration: duration,
                ease: Linear.easeNone
            })?.eventCallback("onUpdate", () => { // to fix #339
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            })
        ]);

        return timeline;
    }

    public getEndingAnimation(): Timeline {
        // const endValue: number = this._endAbortValue;
        const timeline: TimelineLite = new TimelineLite();
        // timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01}));
        // timeline.add(TweenLite.to(this._countUp, 0.2, {alpha: 0}), "+=1"); // stay a while after count up.
        return timeline;
    }

    public getBigWinEndingAnimation(skipedOnLastLevel?: boolean): Timeline {
        const endValue: number = this._endAbortValue;
        const timeline: TimelineLite = new TimelineLite();
        const stayDuration: string = skipedOnLastLevel ? "+=0.5" : "0";
        timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01}));
        timeline.add(TweenLite.to(this._countUp, skipedOnLastLevel ? 1 : 0.2, {alpha: 0}), skipedOnLastLevel); // stay a while after count up.
        return timeline;
    }

    protected initAnimations(): void {
        super.initAnimations();
        this._countUp.maxTextWidth = WGGameConfig.instance.REEL_AREA_WIDTH * 0.93;
    }

    /**
     * not using it for now might use it with some modification
     */
    protected getAbortAnimation(): Timeline {
        return new TimelineLite();
    }
}